<template>
    <v-form :disabled="!isEditableForm">
        <v-dialog transition="dialog-top-transition" v-model="isOpenBaseDialog" persistent max-width="1800">
            <v-card elevation="0">
                <v-card-title primary-title>
                    <v-row dense justify="space-between">
                        <v-col cols="12" sm="8">
                            <div v-if="$vuetify.breakpoint.mdAndDown" :class="`primary--text text-overline ml-2 ${
                                    $vuetify.breakpoint.xs ? 'text-center' : ''
                                }`">
                                {{ form }} -
                                <small>{{ title(window + 1) }}</small>
                            </div>
                            <div v-else class="
                                    font-weight-light
                                    primary--text
                                    text-h4
                                    ml-2
                                    text-capitalize
                                ">
                                {{ form }} -
                                <small>{{ title(window + 1) }}</small>
                            </div>
                        </v-col>
                        <v-col sm="4" cols="12" :class="`d-flex align-center ${
                                $vuetify.breakpoint.smAndDown
                                    ? 'justify-center font-weight-light'
                                    : 'justify-end'
                            }`">
                            <v-switch v-if="type == 'TARIFF'" v-model="tariffIsActive" inset color="green"
                                :label="tariffIsActive ? 'Activa' : 'Inactiva'"></v-switch>
                            <v-switch v-else-if="type == 'ADITIONAL'" v-model="additionalIsActive" inset color="green"
                                :label="
                                    additionalIsActive ? 'Activa' : 'Inactiva'
                                "></v-switch>
                            <v-switch v-else-if="type == 'SVA'" v-model="SVAIsActive" inset color="green"
                                :label="SVAIsActive ? 'Activa' : 'Inactiva'"></v-switch>
                            <v-switch v-else-if="type == 'INSURANCE'" v-model="insuranceIsActive" inset color="green"
                                :label="
                                    insuranceIsActive ? 'Activa' : 'Inactiva'
                                "></v-switch>
                            <v-switch v-else-if="type == 'ADMINISTRATION'" v-model="procedureIsActive" inset
                                color="green" :label="
                                    procedureIsActive ? 'Activa' : 'Inactiva'
                                "></v-switch>
                        </v-col>
                    </v-row>
                </v-card-title>
                <!-- <v-divider class="test"></v-divider> -->
                <v-card-text>
                    <v-row v-if="!$vuetify.breakpoint.smAndDown" align="center">
                        <v-item-group v-model="window" mandatory>
                            <v-item v-for="n in length" :key="n" v-slot="{ active, toggle }">
                                <div>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn :disabled="
                                                    n != 1 && formType == 'add'
                                                " :input-value="active" icon v-bind="attrs" v-on="on" @click="toggle">
                                                {{ n }}
                                                <v-icon size="30" :color="
                                                        active ? 'green' : ''
                                                    ">mdi-record</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>{{ title(n) }}</span>
                                    </v-tooltip>
                                </div>
                            </v-item>
                        </v-item-group>

                        <v-col>
                            <v-window v-model="window" vertical>
                                <v-window-item>
                                    <TariffManagementForm v-if="type == 'TARIFF'" />
                                    <AdditionalManagementForm v-else-if="type == 'ADITIONAL'" />
                                    <SVAManagementForm v-else-if="type == 'SVA'" />
                                    <InsuranceManagementForm v-else-if="type == 'INSURANCE'" />
                                    <ProcedureManagementForm v-else-if="type == 'ADMINISTRATION'" />
                                </v-window-item>
                                <v-window-item>
                                    <PricesUpfrontList :father="type + '_HISTORY_UPFRONT'" />
                                </v-window-item>
                                <v-window-item>
                                    <PricesUpfrontList :father="type + '_HISTORY_PRICE'" />
                                </v-window-item>
                            </v-window>
                        </v-col>
                    </v-row>
                    <div v-else class="d-block align-center">
                        <v-item-group v-model="window" mandatory class="d-flex justify-center mt-4">
                            <v-item v-for="n in length" :key="n" v-slot="{ active, toggle }">
                                <div>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn :disabled="
                                                    n != 1 && formType == 'add'
                                                " :input-value="active" icon v-bind="attrs" v-on="on" @click="toggle">
                                                {{ n }}
                                                <v-icon size="30" :color="
                                                        active ? 'green' : ''
                                                    ">mdi-record</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>{{ title(n) }}</span>
                                    </v-tooltip>
                                </div>
                            </v-item>
                        </v-item-group>

                        <v-window v-model="window" vertical>
                            <v-window-item>
                                <TariffManagementForm v-if="type == 'TARIFF'" />
                                <AdditionalManagementForm v-else-if="type == 'ADITIONAL'" />
                                <SVAManagementForm v-else-if="type == 'SVA'" />
                                <InsuranceManagementForm v-else-if="type == 'INSURANCE'" />
                                <ProcedureManagementForm v-else-if="type == 'ADMINISTRATION'" />
                            </v-window-item>
                            <v-window-item>
                                <PricesUpfrontList :father="type + '_HISTORY_UPFRONT'" />
                            </v-window-item>
                            <v-window-item>
                                <PricesUpfrontList :father="type + '_HISTORY_PRICE'" />
                            </v-window-item>
                        </v-window>
                    </div>
                </v-card-text>
                <v-card-actions class="justify-end">
                    <v-btn depressed color="success" @click="submit" v-if="isEditableForm && window == 0">
                        {{ btnText }}
                    </v-btn>
                    <v-btn text color="red" @click="
                            isOpenBaseDialog = false;
                            reset();
                        ">
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-form>
</template>

<script>
import AdditionalManagementForm from '@/components/GerenciaTeletrabajo/Management/AdditionalManagement/AdditionalManagementForm.vue';
import TariffManagementForm from '@/components/GerenciaTeletrabajo/Management/TariffManagement/TariffManagementForm.vue';
import SVAManagementForm from '@/components/GerenciaTeletrabajo/Management/SVAManagement/SVAManagementForm.vue';
import ProcedureManagementForm from '@/components/GerenciaTeletrabajo/Management/INDBOPROManagement/ProcedureManagement/ProcedureManagementForm.vue';
import InsuranceManagementForm from '@/components/GerenciaTeletrabajo/Management/INDBOPROManagement/InsuranceManagement/InsuranceManagementForm.vue';
import PricesUpfrontList from '@/components/GerenciaTeletrabajo/Management/PricesUpfrontList.vue';

import defaultUpfrontForm from '@/util/management/defaultUpfrontForm.js';
import defaultPriceHistoryForm from '@/util/management/defaultPriceHistoryForm.js';

import { clone } from '@/util/libUtil.js';
import { mapState, mapActions } from 'vuex';

export default {
    data: () => ({
        length: 3,
        window: 0,
        form: '',
    }),
    components: {
        TariffManagementForm,
        AdditionalManagementForm,
        SVAManagementForm,
        ProcedureManagementForm,
        InsuranceManagementForm,
        PricesUpfrontList,
    },
    computed: {
        isEditableForm() {
            return this.formType != 'watch';
        },
        btnText() {
            return this.formType == 'add' ? 'Crear' : 'Editar';
        },
        isOpenBaseDialog: {
            get() {
                return this.$store.state.ManagementBase.baseForm
                    .isOpenBaseDialog;
            },
            set(val) {
                this.$store.commit('ManagementBase/isOpenBaseDialog', val);
            },
        },
        tariffIsActive: {
            get() {
                return this.$store.state.ManagementBase.tariffManagement
                    .isActive;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/tariffManagement/isActive',
                    val
                );
            },
        },
        additionalIsActive: {
            get() {
                return this.$store.state.ManagementBase.additionalManagement
                    .IsActive;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/additionalManagement/IsActive',
                    val
                );
            },
        },
        SVAIsActive: {
            get() {
                return this.$store.state.ManagementBase.SVAManagement.IsActive;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/SVAManagement/IsActive',
                    val
                );
            },
        },
        insuranceIsActive: {
            get() {
                return this.$store.state.ManagementBase.insuranceManagement
                    .IsActive;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/insuranceManagement/IsActive',
                    val
                );
            },
        },
        procedureIsActive: {
            get() {
                return this.$store.state.ManagementBase.procedureManagement
                    .IsActive;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/procedureManagement/IsActive',
                    val
                );
            },
        },
        upfrontHistoryForm: {
            get() {
                return this.$store.state.ManagementBase.baseForm
                    .upfrontHistoryForm;
            },
            set(val) {
                this.$store.commit('ManagementBase/upfrontHistoryForm', val);
            },
        },
        priceHistoryForm: {
            get() {
                return this.$store.state.ManagementBase.baseForm
                    .priceHistoryForm;
            },
            set(val) {
                this.$store.commit('ManagementBase/priceHistoryForm', val);
            },
        },
        search: {
            get() {
                return this.$store.state.util.navBarSearchField;
            },
            set(val) {
                this.$store.commit('util/navBarSearchField', val);
            },
        },
        ...mapState('ManagementBase/', {
            type: (state) => state.baseForm.type,
            formType: (state) => state.baseForm.formType,
            item_id: (state) => state.baseForm.item_id,
        }),
    },
    methods: {
        title(index) {
            switch (index) {
                case 1:
                    return 'Datos Generales';
                case 2:
                    return 'Histórico de Upfront';
                default:
                    return 'Histórico de Precios';
            }
        },
        reset() {
            this.window = 0;
            this.$store.commit(
                'ManagementBase/upfrontHistoryForm',
                clone(defaultUpfrontForm)
            );
            this.$store.commit(
                'ManagementBase/priceHistoryForm',
                clone(defaultPriceHistoryForm)
            );

            switch (this.type) {
                case 'TARIFF':
                    this.$store.commit(
                        'ManagementBase/tariffManagement/resetStore'
                    );
                    break;
                case 'ADITIONAL':
                    this.$store.commit(
                        'ManagementBase/additionalManagement/resetStore'
                    );
                    break;
                case 'SVA':
                    this.$store.commit(
                        'ManagementBase/SVAManagement/resetStore'
                    );
                    break;
                case 'INSURANCE':
                    this.$store.commit(
                        'ManagementBase/insuranceManagement/resetStore'
                    );
                    break;
                case 'ADMINISTRATION':
                    this.$store.commit(
                        'ManagementBase/procedureManagement/resetStore'
                    );
                    break;
                default:
                    break;
            }
        },
        submit() {
            switch (this.type) {
                case 'TARIFF':
                    if (this.formType == 'add') this.addTariff();
                    else this.editTariff();

                    this.search =
                        this.$store.state.ManagementBase.tariffManagement.name;
                    this.$store.commit(
                        'ManagementBase/isOpenBaseDialog',
                        false
                    );
                    break;
                case 'ADITIONAL':
                    if (this.formType == 'add') this.addAdditional();
                    else this.editAdditional();

                    this.search =
                        this.$store.state.ManagementBase.additionalManagement.Name;
                    this.$store.commit(
                        'ManagementBase/isOpenBaseDialog',
                        false
                    );
                    break;
                case 'SVA':
                    if (this.formType == 'add') this.addSva();
                    else this.editSva();

                    this.search =
                        this.$store.state.ManagementBase.SVAManagement.Name;
                    this.$store.commit(
                        'ManagementBase/isOpenBaseDialog',
                        false
                    );
                    break;
                case 'INSURANCE':
                    if (this.formType == 'add') this.addInsurance();
                    else this.editInsurance();

                    this.search =
                        this.$store.state.ManagementBase.insuranceManagement.Name;
                    this.$store.commit(
                        'ManagementBase/isOpenBaseDialog',
                        false
                    );
                    break;
                case 'ADMINISTRATION':
                    if (this.formType == 'add') this.addProcedure();
                    else this.editProcedure();

                    this.search =
                        this.$store.state.ManagementBase.procedureManagement.Name;
                    this.$store.commit(
                        'ManagementBase/isOpenBaseDialog',
                        false
                    );
                    break;
                default:
                    break;
            }
        },
        ...mapActions('ManagementBase/tariffManagement', [
            'addTariff',
            'editTariff',
        ]),
        ...mapActions('ManagementBase/additionalManagement', [
            'addAdditional',
            'editAdditional',
        ]),
        ...mapActions('ManagementBase/SVAManagement', ['addSva', 'editSva']),
        ...mapActions('ManagementBase/insuranceManagement', [
            'addInsurance',
            'editInsurance',
        ]),
        ...mapActions('ManagementBase/procedureManagement', [
            'addProcedure',
            'editProcedure',
        ]),
    },
    updated() {
        switch (this.type) {
            case 'TARIFF':
                this.length = 3;
                this.content_type = 25;
                this.form = 'Tarifa';
                break;
            case 'ADITIONAL':
                this.length = 3;
                this.content_type = 18;
                this.form = 'Adicional';
                break;
            case 'SVA':
                this.length = 3;
                this.content_type = 24;
                this.form = 'SVA';
                break;
            case 'INSURANCE':
                this.length = 2;
                this.content_type = 23;
                this.form = 'Seguro';
                break;
            case 'ADMINISTRATION':
                this.length = 2;
                this.content_type = 21;
                this.form = 'Gestion';
                break;
            default:
                break;
        }

        this.priceHistoryForm.object_id = this.item_id;
        this.priceHistoryForm.content_type = this.content_type;

        this.upfrontHistoryForm.object_id = this.item_id;
        this.upfrontHistoryForm.content_type = this.content_type;
    },
};
</script>